import { toast } from "react-toastify";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "../../components/Spinner";
import { useValidateInvite } from "../../helpers/queries/auth/useGetAuth";
// import { BASE_URL } from "../../helpers/api";

const ValidateInvite = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const expires = queryParams.get("expires");
  const user = queryParams.get("user");
  const signature = queryParams.get("signature");

  // const URL = `${BASE_URL}${location.pathname}?expires=${expires}&user=${user}&signature=${signature}`

  const { isValidating, isSuccess, isError, data, error } = useValidateInvite(
    expires,
    user,
    signature
  );

  useEffect(() => {
    if (!isValidating && isSuccess) {
      sessionStorage.setItem("authToken", data.token);
      navigate("/dashboard", { state: { data: data } });
    } else if (isError) {
      toast.error(error.message);
      navigate("/");
    }
    // eslint-disable-next-line
  }, [isSuccess, isError, isValidating]);

  return (
    <>
      {isValidating && (
        <div className=" h-screen w-full flex items-center justify-center">
          <Spinner />
        </div>
      )}
      {isError && (
        <div className=" h-screen w-full flex flex-col gap-3 items-center justify-center">
          <p className=" text-[#293056] font-bold text-2xl">
            There was an error validating your account
          </p>

          <p className=" text-[#667085] text-sm ">
            You will be redirected to the sign up screen
          </p>
        </div>
      )}
    </>
  );
};

export default ValidateInvite;
